import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import { legend100, headline30 } from "css/text"
import { FocusScope } from "@react-aria/focus"

import ModalContainer, { priceModal } from "components/modal/ModalContainer"

const Heading = styled.h2`
  ${headline30}
  &:not(:first-of-type) {
    margin-block-start: 3.75rem;
  }
  margin-block-end: 1ex;
`

const Paragraph = styled.div`
  ${legend100}

  p:not(:last-of-type) {
    margin-block-end: 2ex;
  }
`

function PriceModalScope({ children, scope }) {
  return scope ? (
    <FocusScope contain restoreFocus autoFocus>
      {children}
    </FocusScope>
  ) : (
    children
  )
}

export default function PriceModal({
  onClose,
  isWatch,
  formattedPrice,
  priceTitle,
  legalNotice,
  onDemandTitle,
  onDemandNotice,
  scarcityTitle,
  scarcityText,
  scope,
  accessoriesLegalNotice,
  id,
}) {
  const console = useConsole()

  return (
    <PriceModalScope scope>
      <ModalContainer onClose={onClose} className={priceModal} modalHeading='modal-heading' id={id}>
        <Heading id='modal-heading'>{formattedPrice ? priceTitle : onDemandTitle}</Heading>
        <Paragraph dangerouslySetInnerHTML={{ __html: formattedPrice ? (isWatch ? legalNotice : accessoriesLegalNotice) : onDemandNotice }} />
        {isWatch && (
          <>
            <Heading>{scarcityTitle}</Heading>
            <Paragraph dangerouslySetInnerHTML={{ __html: scarcityText }} />
          </>
        )}
      </ModalContainer>
    </PriceModalScope>
  )
}
